import { connect } from 'react-redux';

import StatementEditPage from 'pages/statement-edit-page';
import { finishStatementEdit } from 'store/actions/statement-edit-actions';
import { updateSelectedProjectFromIDIfDoesNotExists } from 'store/actions/selected-project-actions';
import { fetchStatementCreationPageData } from 'store/actions/statement-creation-page-data-actions';

const mapDispatchToProps = {
  finishStatementEdit,
  updateSelectedProjectFromIDIfDoesNotExists,
  fetchStatementCreationPageData,
};

export default connect(null, mapDispatchToProps)(StatementEditPage);
